module.exports = __webpack_public_path__ + "img/crecemos.185c4589.png";